var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "inventoryImages" },
      [
        _vm.images.length == 0
          ? _c("p", [_vm._v(_vm._s(_vm.count))])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.images, function(image, index) {
          return _c("img", {
            staticClass: "thumbnail",
            style: "max-height:" + _vm.height,
            attrs: {
              id: "thumbnail" + _vm.inventorypic_id + "-" + index,
              alt: _vm.dir,
              src: image
            },
            on: {
              click: function($event) {
                return _vm.imageClick(index)
              }
            }
          })
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: { id: "myModal" + _vm.inventorypic_id },
        on: { click: _vm.close }
      },
      [
        _c("img", {
          staticClass: "modal-content",
          attrs: { id: "img" + _vm.inventorypic_id }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84a0c614", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84a0c614","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/inventorypics.vue
// module id = 861
// module chunks = 0